module.exports = __webpack_public_path__ + "img/icon_map_1_off_010.01edcdce.png";